export type SortOrder = "asc" | "desc";

export function matchesTextFilter(
  value: string | number | null | undefined,
  filter: string,
): boolean {
  if (!filter.trim()) return true;
  return String(value ?? "")
    .toLowerCase()
    .includes(filter.trim().toLowerCase());
}

/** Matches "active", "inactive", "yes", "no", etc. against boolean status. */
export function matchesStatusFilter(
  isActive: boolean,
  filter: string,
): boolean {
  if (!filter.trim()) return true;
  const term = filter.trim().toLowerCase();
  const label = isActive ? "active" : "inactive";
  return (
    label.includes(term) ||
    (isActive && (term === "yes" || term === "1" || term === "true")) ||
    (!isActive && (term === "no" || term === "0" || term === "false"))
  );
}

export function compareSortValues(
  a: string | number,
  b: string | number,
  order: SortOrder,
): number {
  if (typeof a === "number" && typeof b === "number") {
    return order === "asc" ? a - b : b - a;
  }
  const cmp = String(a).localeCompare(String(b), undefined, {
    sensitivity: "base",
  });
  return order === "asc" ? cmp : -cmp;
}

export function hasActiveFilters(filters: Record<string, string>): boolean {
  return Object.values(filters).some((v) => v.trim().length > 0);
}
